<template>
    <div class="wrapper">
        <div class="page-header clear-filter header-filter" filter-color="orange">
            <div class="rellax-header rellax-header-sky" data-rellax-speed="-8">
                <div class="page-header-image"
                     style="background-image: url('img/presentation-page/nuk-pro-back-sky.jpg')">
                </div>
            </div>
            <div class="rellax-header rellax-header-buildings" data-rellax-speed="0">
                <div class="page-header-image page-header-city"
                     style="background-image: url('img/presentation-page/nuk-pro-buildings.png')">
                </div>
            </div>
            <div class="rellax-text-container">
                <h1 class="h1-seo rellax-text" data-rellax-speed="-2">Components</h1>
            </div>
            <h3 class="h3-description rellax-text" data-rellax-speed="-1">A beautiful premium Bootstrap 4 UI
                Kit.</h3>
            <h6 class="category category-absolute rellax-text" data-rellax-speed="-2">Designed by
                <a href="https:///invisionapp.com/" target="_blank">
                    <img v-lazy="'img/invision-white-slim.png'" class="invision-logo"/>
                </a>. Coded by
                <a href="https://www.creative-tim.com" target="_blank">
                    <img v-lazy="'img/creative-tim-white-slim2.png'" class="creative-tim-logo" alt=""/>
                </a>.</h6>
        </div>
        <div class="main">
            <images-section></images-section>
            <basic-elements-section></basic-elements-section>
            <navigation></navigation>
            <tabs-section></tabs-section>
            <pills-section></pills-section>
            <progress-pagination-section></progress-pagination-section>
            <notification-section></notification-section>
            <pre-footer-areas></pre-footer-areas>
            <footer-areas></footer-areas>
            <typography-tables></typography-tables>
            <cards-section></cards-section>
            <javascript-components></javascript-components>
            <carousel-section></carousel-section>
            <nucleo-icons-section></nucleo-icons-section>



<div class="container">
    <!-- 
        .now-ui-icons.ui-1_check:before {
            content: "\ea22";
        }

        .now-ui-icons.ui-1_email-85:before {
            content: "\ea2a";
        }

        .now-ui-icons.arrows-1_cloud-download-93:before {
            content: "\ea21";
        }

        .now-ui-icons.arrows-1_cloud-upload-94:before {
            content: "\ea24";
        }

        .now-ui-icons.arrows-1_minimal-down:before {
            content: "\ea39";
        }

        .now-ui-icons.arrows-1_minimal-left:before {
            content: "\ea3a";
        }

        .now-ui-icons.arrows-1_minimal-right:before {
            content: "\ea3b";
        }

        .now-ui-icons.arrows-1_minimal-up:before {
            content: "\ea3c";
        }

        .now-ui-icons.arrows-1_refresh-69:before {
            content: "\ea44";
        }

        .now-ui-icons.arrows-1_share-66:before {
            content: "\ea4c";
        }

        .now-ui-icons.business_badge:before {
            content: "\ea09";
        }

        .now-ui-icons.business_bank:before {
            content: "\ea0a";
        }

        .now-ui-icons.business_briefcase-24:before {
            content: "\ea13";
        }

        .now-ui-icons.business_bulb-63:before {
            content: "\ea15";
        }

        .now-ui-icons.business_chart-bar-32:before {
            content: "\ea1e";
        }

        .now-ui-icons.business_chart-pie-36:before {
            content: "\ea1f";
        }

        .now-ui-icons.business_globe:before {
            content: "\ea2f";
        }

        .now-ui-icons.business_money-coins:before {
            content: "\ea40";
        }

        .now-ui-icons.clothes_tie-bow:before {
            content: "\ea5b";
        }

        .now-ui-icons.design_vector:before {
            content: "\ea61";
        }

        .now-ui-icons.design_app:before {
            content: "\ea08";
        }

        .now-ui-icons.design_bullet-list-67:before {
            content: "\ea14";
        }

        .now-ui-icons.design_image:before {
            content: "\ea33";
        }

        .now-ui-icons.design_palette:before {
            content: "\ea41";
        }

        .now-ui-icons.design_scissors:before {
            content: "\ea4a";
        }

        .now-ui-icons.design-2_html5:before {
            content: "\ea32";
        }

        .now-ui-icons.design-2_ruler-pencil:before {
            content: "\ea48";
        }

        .now-ui-icons.emoticons_satisfied:before {
            content: "\ea49";
        }

        .now-ui-icons.files_box:before {
            content: "\ea12";
        }

        .now-ui-icons.files_paper:before {
            content: "\ea43";
        }

        .now-ui-icons.files_single-copy-04:before {
            content: "\ea52";
        }

        .now-ui-icons.health_ambulance:before {
            content: "\ea07";
        }

        .now-ui-icons.loader_gear:before {
            content: "\ea4e";
        }

        .now-ui-icons.loader_refresh:before {
            content: "\ea44";
        }

        .now-ui-icons.location_bookmark:before {
            content: "\ea10";
        }

        .now-ui-icons.location_compass-05:before {
            content: "\ea25";
        }

        .now-ui-icons.location_map-big:before {
            content: "\ea3d";
        }

        .now-ui-icons.location_pin:before {
            content: "\ea47";
        }

        .now-ui-icons.location_world:before {
            content: "\ea63";
        }

        .now-ui-icons.media-1_album:before {
            content: "\ea02";
        }

        .now-ui-icons.media-1_button-pause:before {
            content: "\ea16";
        }

        .now-ui-icons.media-1_button-play:before {
            content: "\ea18";
        }

        .now-ui-icons.media-1_button-power:before {
            content: "\ea19";
        }

        .now-ui-icons.media-1_camera-compact:before {
            content: "\ea1c";
        }

        .now-ui-icons.media-2_note-03:before {
            content: "\ea3f";
        }

        .now-ui-icons.media-2_sound-wave:before {
            content: "\ea57";
        }

        .now-ui-icons.objects_diamond:before {
            content: "\ea29";
        }

        .now-ui-icons.objects_globe:before {
            content: "\ea2f";
        }

        .now-ui-icons.objects_key-25:before {
            content: "\ea38";
        }

        .now-ui-icons.objects_planet:before {
            content: "\ea46";
        }

        .now-ui-icons.objects_spaceship:before {
            content: "\ea55";
        }

        .now-ui-icons.objects_support-17:before {
            content: "\ea56";
        }

        .now-ui-icons.objects_umbrella-13:before {
            content: "\ea5f";
        }

        .now-ui-icons.education_agenda-bookmark:before {
            content: "\ea01";
        }

        .now-ui-icons.education_atom:before {
            content: "\ea0c";
        }

        .now-ui-icons.education_glasses:before {
            content: "\ea2d";
        }

        .now-ui-icons.education_hat:before {
            content: "\ea30";
        }

        .now-ui-icons.education_paper:before {
            content: "\ea42";
        }

        .now-ui-icons.shopping_bag-16:before {
            content: "\ea0d";
        }

        .now-ui-icons.shopping_basket:before {
            content: "\ea0b";
        }

        .now-ui-icons.shopping_box:before {
            content: "\ea11";
        }

        .now-ui-icons.shopping_cart-simple:before {
            content: "\ea1d";
        }

        .now-ui-icons.shopping_credit-card:before {
            content: "\ea28";
        }

        .now-ui-icons.shopping_delivery-fast:before {
            content: "\ea27";
        }

        .now-ui-icons.shopping_shop:before {
            content: "\ea50";
        }

        .now-ui-icons.shopping_tag-content:before {
            content: "\ea59";
        }

        .now-ui-icons.sport_trophy:before {
            content: "\ea5d";
        }

        .now-ui-icons.sport_user-run:before {
            content: "\ea60";
        }

        .now-ui-icons.tech_controller-modern:before {
            content: "\ea26";
        }

        .now-ui-icons.tech_headphones:before {
            content: "\ea31";
        }

        .now-ui-icons.tech_laptop:before {
            content: "\ea36";
        }

        .now-ui-icons.tech_mobile:before {
            content: "\ea3e";
        }

        .now-ui-icons.tech_tablet:before {
            content: "\ea58";
        }

        .now-ui-icons.tech_tv:before {
            content: "\ea5e";
        }

        .now-ui-icons.tech_watch-time:before {
            content: "\ea62";
        }

        .now-ui-icons.text_align-center:before {
            content: "\ea05";
        }

        .now-ui-icons.text_align-left:before {
            content: "\ea06";
        }


-->
<p><i class="now-ui-icons travel_info"></i>INICIO</p>
            <p><i class="now-ui-icons transportation_bus-front-12"></i>INICIO</p>
            <p><i class="now-ui-icons transportation_air-baloon"></i>INICIO</p>
            <p><i class="now-ui-icons transportation_bus-front-12"></i>INICIO</p>
            <p><i class="now-ui-icons gestures_tap-01"></i>INICIO</p>
            <p><i class="now-ui-icons text_caps-small"></i>INICIO</p>
            <p><i class="now-ui-icons text_bold"></i>INICIO</p>
            <p><i class="now-ui-icons business_bank"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_bell-53"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_bell-53"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_bell-53"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_bell-53"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_bell-53"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_bell-53"></i>INICIO</p>

            <p><i class="now-ui-icons users_single-02"></i>INICIO</p>
            <p><i class="now-ui-icons users_circle-08"></i>INICIO</p>
            <p><i class="now-ui-icons ui-2_time-alarm"></i>INICIO</p>
            <p><i class="now-ui-icons ui-2_settings-90"></i>INICIO</p>
            <p><i class="now-ui-icons ui-2_favourite-28"></i>INICIO</p>
            <p><i class="now-ui-icons ui-2_chat-round"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_zoom-bold"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_simple-remove"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_simple-delete"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_simple-add"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_settings-gear-63"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_send"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_lock-circle-open"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_calendar-60"></i>INICIO</p>
            <p><i class="now-ui-icons ui-1_bell-53"></i>INICIO</p>
            <p><i class="now-ui-icons travel_istanbul"></i>INICIO</p>
</div>

            
            

        </div>
    </div>
</template>

<script>
  import ImagesSection from './components/ImagesSection'
  import BasicElementsSection from "./components/BasicElementsSection";
  import Navigation from './components/Navigation';
  import TabsSection from './components/Tabs';
  import PillsSection from './components/Pills';
  import ProgressPaginationSection from './components/ProgressPagination';
  import NotificationSection from './components/Notifications';
  import PreFooterAreas from './components/PreFooters';
  import FooterAreas from './components/Footers';
  import TypographyTables from './components/TypographyTables';
  import CardsSection from './components/Cards';
  const JavascriptComponents = () =>  import('./components/JavascriptComponents');
  import CarouselSection from './components/CarouselSection';
  import NucleoIconsSection from './components/NucleoIconsSection';

  export default {
    name: "home",
    bodyClass: 'index-page',
    components: {
      BasicElementsSection,
      ImagesSection,
      Navigation,
      TabsSection,
      PillsSection,
      ProgressPaginationSection,
      NotificationSection,
      PreFooterAreas,
      FooterAreas,
      TypographyTables,
      CardsSection,
      JavascriptComponents,
      CarouselSection,
      NucleoIconsSection
    }
  };
</script>
